import axios from 'axios';


export default {
    submit(data) {

        var options = {
            method: 'PUT',
            url: window.apiUrl + '/artstation',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            data: data
            
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },
    get() {

        var options = {
            method: 'GET',
            url: window.apiUrl + '/artstation',
            headers: { 'Authorization': 'Bearer ' + localStorage.token },
            
        };

        return axios.request(options).then(function(response) {
            return response;
        });

    },
}


// WEBPACK FOOTER //
// ./src/services/artstation/index.js